import { Image } from "antd";
import {
  useEffect,
  useState
} from "react";

export default function ImageGallery({
  product_image
}) {
  const [current, setCurrent] =
    useState(0);

  const images =
    Array.isArray(product_image)
      ? product_image.filter(Boolean)
      : [];

  useEffect(() => {
    setCurrent(0);
  }, [product_image]);

  if (!images.length) {
    return (
      <div className="cyk-product-gallery cyk-product-gallery-empty">
        <div className="cyk-product-gallery-placeholder">
          Chưa có hình ảnh
        </div>
      </div>
    );
  }

  const safeCurrent =
    current < images.length
      ? current
      : 0;

  return (
    <div className="cyk-product-gallery">
      <div className="cyk-product-gallery-main">
        <Image
          src={images[safeCurrent]}
          alt="Hình ảnh sản phẩm"
          preview
        />
      </div>

      {images.length > 1 && (
        <div className="cyk-product-gallery-thumbs">
          {images.map(
            (src, index) => (
              <button
                type="button"
                key={`${src}-${index}`}
                className={`cyk-product-gallery-thumb ${
                  index === safeCurrent
                    ? "is-active"
                    : ""
                }`}
                onClick={() =>
                  setCurrent(index)
                }
                onMouseEnter={() =>
                  setCurrent(index)
                }
                aria-label={`Ảnh sản phẩm ${
                  index + 1
                }`}
              >
                <img
                  src={src}
                  alt=""
                  loading="lazy"
                  decoding="async"
                />
              </button>
            )
          )}
        </div>
      )}
    </div>
  );
}
